import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { Field, Input } from '@fluentui/react-components'
import { DocketEntryDto, DocketProceedingType } from './DocketProceedingForm'
import { DocketEntryDialogProps } from './DocketEntryDialog'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import FormContainer from '../../../components/Form/FormContainer'
import LocalDatePicker from '../../../components/DatePicker/LocalDatePicker'

export default function DocketEntryFormContainer(props: DocketEntryDialogProps): ReactElement {
    const { values, errors, setFieldValue } = useFormikContext<DocketEntryDto>()
    const themeClassName = useThemeClassName_unstable()

    return (
        <FormContainer>
            <Field
                label="Datum"
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.date ? 'error' : undefined}
                validationMessage={errors.date}
            >
                <LocalDatePicker
                    popupSurface={{ className: themeClassName }}
                    isoValue={values.date}
                    onSelectDate={date => {
                        setFieldValue('date', date)
                    }}
                />
            </Field>
            <Field
                label="Rolhandeling"
                required
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.title ? 'error' : undefined}
                validationMessage={errors.title}
            >
                <Input
                    value={values.title || ''}
                    onChange={(_, data) => {
                        setFieldValue('title', data.value)
                    }}
                />
            </Field>
            {props.selected.type !== DocketProceedingType.CourtOfAppeal && (
                <Field
                    label="Status"
                    orientation={props.orientation}
                    className={props.styles.field}
                    validationState={errors.status ? 'error' : undefined}
                    validationMessage={errors.status}
                >
                    <Input
                        value={values.status || ''}
                        onChange={(_, data) => {
                            setFieldValue(`status`, data.value)
                        }}
                    />
                </Field>
            )}
            <Field
                label="Aanvulling"
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.supplement ? 'error' : undefined}
                validationMessage={errors.supplement}
            >
                <Input
                    value={values.supplement || ''}
                    onChange={(_, data) => {
                        setFieldValue(`supplement`, data.value)
                    }}
                />
            </Field>
            {props.selected.type === DocketProceedingType.CourtOfAppeal && (
                <Field
                    label="Uitkomst"
                    orientation={props.orientation}
                    className={props.styles.field}
                    validationState={errors.result ? 'error' : undefined}
                    validationMessage={errors.result}
                >
                    <Input
                        value={values.result || ''}
                        onChange={(_, data) => {
                            setFieldValue(`result`, data.value)
                        }}
                    />
                </Field>
            )}
            <Field
                label="Opmerking"
                orientation={props.orientation}
                className={props.styles.field}
                validationState={errors.remark ? 'error' : undefined}
                validationMessage={errors.remark}
            >
                <Input
                    value={values.remark || ''}
                    onChange={(_, data) => {
                        setFieldValue(`remark`, data.value)
                    }}
                />
            </Field>
        </FormContainer>
    )
}
